export default "__VITE_ASSET__Cq4eo34c__"